module.exports = __webpack_public_path__ + "img/Policies Icon - charcoal.2f487833.svg";